/* Aurah Living redesign behaviour: reveal, set builder, gift tabs, add-to-cart into the theme's drawer. */
(function () {
  'use strict';
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var loc = { USD: 'en-US', GBP: 'en-GB', EUR: 'de-DE', CAD: 'en-CA', AUD: 'en-AU', AED: 'en-AE' }[cur] || 'en';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function toast(title, desc) {
    var root = document.getElementById('ToastRoot'); if (!root) return;
    var t = document.createElement('div'); t.className = 'toast';
    t.innerHTML = '<p class="toast__title">' + esc(title) + '</p>' + (desc ? '<p class="toast__desc">' + esc(desc) + '</p>' : '');
    root.appendChild(t); requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); }, 3500);
  }
  /* Same cart-item markup as theme.js so the drawer looks identical. */
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; if (el.classList.contains('cart-count')) el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none'; });
    var body = document.querySelector('[data-cart-body]'); if (!body) return;
    var foot = document.querySelector('[data-cart-foot]'); if (foot) foot.style.display = 'flex';
    body.innerHTML = cart.items.map(function (it) {
      return '<div class="cart-item" data-cart-item data-line-key="' + it.key + '">' +
        '<a href="' + it.url + '" class="cart-item__media" data-drawer-close><img src="' + (it.image || '') + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
        '<div class="cart-item__body"><div><a href="' + it.url + '" class="cart-item__name" data-drawer-close>' + esc(it.product_title) + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cart-item__price">' + esc(it.variant_title) + '</p>' : '') +
        '<p class="cart-item__price">' + money(it.final_line_price) + '</p></div>' +
        '<div class="cart-item__foot"><div class="qty"><button type="button" aria-label="Decrease" data-cart-qty="' + it.key + '" data-delta="-1">−</button><span class="qty__value">' + it.quantity + '</span><button type="button" aria-label="Increase" data-cart-qty="' + it.key + '" data-delta="1">+</button></div>' +
        '<button type="button" class="cart-item__remove" data-cart-remove="' + it.key + '">Remove</button></div></div></div>';
    }).join('');
    var sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
  }
  function openCart() {
    var el = document.getElementById('CartDrawer'); if (!el) return;
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    el.classList.add('is-open'); document.body.style.overflow = 'hidden';
  }
  function addLines(items) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || "Couldn't add to cart"); return d; }); })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); openCart(); return cart; });
  }

  /* reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -6% 0px' }) : null;
  function reveal(root) { (root || document).querySelectorAll('.ar-rv:not(.is-in)').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); }); }

  /* set builder */
  function initSet(root) {
    (root || document).querySelectorAll('[data-ar-set]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var boxes = sec.querySelectorAll('[data-ar-pick]'), sum = sec.querySelector('[data-ar-sum]'), btn = sec.querySelector('[data-ar-addset]');
      var cur = 0, raf;
      function target() { var s = 0, n = 0; boxes.forEach(function (b) { b.closest('.ar-pick').classList.toggle('is-off', !b.checked); if (b.checked) { s += Number(b.dataset.price); n++; } }); btn.disabled = n === 0; return s; }
      function anim(to) {
        cancelAnimationFrame(raf); var from = cur, st = performance.now();
        (function f(now) { var k = Math.min(1, (now - st) / 450), e = 1 - Math.pow(1 - k, 3); cur = from + (to - from) * e; sum.textContent = money(Math.round(cur)); if (k < 1) raf = requestAnimationFrame(f); })(st);
      }
      cur = target(); sum.textContent = money(cur);
      boxes.forEach(function (b) { b.addEventListener('change', function () { anim(target()); }); });
      btn.addEventListener('click', function () {
        var items = []; boxes.forEach(function (b) { if (b.checked && b.dataset.available === 'true') items.push({ id: Number(b.value), quantity: 1 }); });
        if (!items.length) return;
        btn.setAttribute('aria-busy', 'true');
        addLines(items).then(function () { toast('The set is in your cart', items.length + (items.length === 1 ? ' piece' : ' pieces')); })
          .catch(function (err) { toast('Could not add', err.message); })
          .then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* gift tabs */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-ar-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var tabs = wrap.querySelectorAll('[role=tab]');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; }); });
        t.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); n.click(); });
      });
    });
  }

  function init(root) { reveal(root); initSet(root); initTabs(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ar-search-focus: when the search drawer opens, put the cursor in the search box */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-drawer-open="SearchDrawer"]');
    if (!b) return;
    var tries = 0;
    var f = function () {
      var i = document.querySelector('#SearchDrawer input[type="search"], #SearchDrawer input[name="q"]');
      if (i && document.getElementById('SearchDrawer').classList.contains('is-open')) { i.focus(); return; }
      if (tries++ < 20) setTimeout(f, 40);
    };
    setTimeout(f, 260);
  });
})();
